import { render, staticRenderFns } from "./SubmitProject.vue?vue&type=template&id=ba825fac&scoped=true&"
import script from "./SubmitProject.vue?vue&type=script&lang=js&"
export * from "./SubmitProject.vue?vue&type=script&lang=js&"
import style0 from "./SubmitProject.vue?vue&type=style&index=0&id=ba825fac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba825fac",
  null
  
)

export default component.exports